import { Button, Form, type FormProps, Input, Modal } from 'antd'
import React, { useState } from 'react'

import { useNotifications } from '@store/notifications'

type ModalProps = {
    isOpen: boolean
    onClose: () => void
    onAddFeatureFlag: (key: string) => Promise<void>
}

export const AddFeatureFlagModal: React.FC<ModalProps> = ({ isOpen, onClose, onAddFeatureFlag }) => {
    const [isLoading, setIsLoading] = useState(false)
    const { showNotification } = useNotifications()

    const onConfirm: FormProps<any>['onFinish'] = async values => {
        setIsLoading(true)
        try {
            await onAddFeatureFlag(values.key)
            showNotification({
                title: 'Feature flag rule has been added'
            })
            onClose()
        } catch (err: any) {
            showNotification({
                type: 'error',
                title: 'Failed to add feature flag',
                description: err.toString()
            })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal open={isOpen} footer={[]} onCancel={onClose}>
            <Form
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 14 }}
                layout="horizontal"
                disabled={false}
                onFinish={onConfirm}
            >
                <h3>Add Feature Flag</h3>
                <Form.Item label="Feature Flag Key" name="key">
                    <Input />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit" loading={isLoading} disabled={isLoading}>
                        Add
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    )
}
